import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ReportPublicDataApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'reportPublicData';
    }

}